import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class EssensysOnlinePlanError extends CodedError {
  static get errorName() {
    return errorCodes.essensysOnlinePlanError.code;
  }

  constructor(message: string = errorCodes.essensysOnlinePlanError.message) {
    super(message);
    this.code = errorCodes.essensysOnlinePlanError.code;
    this.message = `${message} ${errorCodes.essensysOnlinePlanError.code}`;
    this.name = errorCodes.essensysOnlinePlanError.name;
  }
}
